export type Asset<T> = {
  created: string;
  anon_identifier?: string;
  data: T;
  enc_data: string;
  value: string;
  id: string;
  indent: number;
  order: number;
  pack_id: string;
  type: 'html' | 'text' | 'link' | 'file' | 'prompt';
  updated: string;
  user_id: string;
}

export enum FieldTypes {
  TEXT = 'text',
  LINK = 'link',
  HTML = 'html',
  FILE = 'file',
  PROMPT = 'prompt',
  UNKNOWN = 'unknown',
}

export enum FieldTypeKeys {
  TEXT = '/text',
  LINK = '/link',
  HTML = '/html',
  FILE = '/file',
  PROMPT = '/prompt'
}

export enum FieldMode {
  DISPLAY = 'DISPLAY',
  EDIT = 'EDIT',
  CREATE = 'CREATE',
}
